import { render, staticRenderFns } from "./VehicleBrief.vue?vue&type=template&id=b56c23f4"
import script from "./VehicleBrief.vue?vue&type=script&lang=js"
export * from "./VehicleBrief.vue?vue&type=script&lang=js"
import style0 from "./VehicleBrief.vue?vue&type=style&index=0&id=b56c23f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports